import React from 'react';
import type { PublicReply } from '@find-my-part/types';
import { ReplyItem } from './ReplyItem';

export interface ReplyListProps {
  replies: PublicReply[];
}

export function ReplyList({ replies }: ReplyListProps): React.ReactElement {
  // Separate solution replies from regular replies
  const solutionReplies = replies.filter((r) => r.isSolution);
  const otherReplies = [...replies]
    .filter((r) => !r.isSolution)
    .sort((a, b) => a.createdAt - b.createdAt);

  return (
    <div className="fmp-reply-list">
      {replies.length === 0 ? (
        <p className="fmp-reply-list__empty" aria-live="polite">
          No answers yet. Check back later for responses.
        </p>
      ) : (
        <>
          <h3 className="fmp-reply-list__heading">
            {replies.length} {replies.length === 1 ? 'Reply' : 'Replies'}
          </h3>

          {/* Elevated solution section */}
          {solutionReplies.length > 0 && (
            <div className="fmp-best-answer" role="region" aria-label="Best answer">
              <h4 className="fmp-best-answer__heading">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true" className="fmp-best-answer__icon">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Best Answer
              </h4>
              <ul className="fmp-reply-list__items" role="list">
                {solutionReplies.map((reply) => (
                  <ReplyItem key={reply.replyId} reply={reply} />
                ))}
              </ul>
            </div>
          )}

          {/* Remaining replies */}
          {otherReplies.length > 0 && (
            <ul className="fmp-reply-list__items" role="list">
              {otherReplies.map((reply) => (
                <ReplyItem key={reply.replyId} reply={reply} />
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
}
